import {isValidPhoneNumber} from 'libphonenumber-js';

import {LeadFormFieldDescriptor} from '../LeadFormFieldWithLabel';

const phoneNumberValidator = (value: string) => {
  if (isValidPhoneNumber(value, 'US')) {
    return true;
  } else {
    return 'Please enter a valid phone number. (If not in the US, please include +CountryCode).';
  }
};

// From the quoted "99.99% cases covered" regex in this StackOverflow answer: https://stackoverflow.com/a/1373724
const VALID_EMAIL_REGEX =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const emailAddressValidator = (value: string) => {
  const isValidEmail = VALID_EMAIL_REGEX.test(value);
  return isValidEmail || 'Please enter a valid email address.';
};

const urlValidator = (value: string) => {
  let url;
  const updatedValue = value.toLowerCase().substring(0, 4) === 'www.' ? `https://${value}` : value;

  const errorMessage = 'Please provide a valid URL.';

  // https://stackoverflow.com/a/43467144
  try {
    url = new URL(updatedValue);
  } catch (_) {
    return errorMessage;
  }

  if (url.protocol === 'http:' || url.protocol === 'https:') {
    return true;
  } else {
    return errorMessage;
  }
};

export const getValidateFunction = (
  type: LeadFormFieldDescriptor['_type'],
): ((value: string) => true | string) | undefined => {
  if (type === 'phoneNumberInput') {
    return phoneNumberValidator;
  } else if (type === 'emailInput') {
    return emailAddressValidator;
  } else if (type === 'urlInput') {
    return urlValidator;
  }

  return undefined;
};
